import React from 'react';
import Box from '@mui/material/Box';
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
// import TrustBar from '../../common/TrustBar';
import ProductCarouselSection from './components/ProductCarouselSection';
import CategoryShowcase from './components/CategoryShowcase';
import WhyChooseUs from './components/WhyChooseUs';
import ProcessWalkthrough from './components/ProcessWalkthrough';
import Testimonials from './components/Testimonials';
import TopCategories from './components/TopCategories';
import HealthEducation from './components/HealthEducation';
import SEO from '../../common/SEO';
import { motion } from 'framer-motion';

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 }
};

const HomePage = () => {
  return (
    <Box>
      <SEO
        title="Original Windows, Office & Server Licenses"
        description="Get genuine Microsoft software keys for Windows 10, Windows 11, Office Professional Plus, and Windows Server Standard. Instant email delivery, lifetime activation, and 24/7 technical support."
      />
      <Hero />


      <motion.div {...fadeInUp}>
        <TopCategories />
      </motion.div>

      {/* <motion.div {...fadeInUp}>
        <TrustBar />
      </motion.div> */}

      <motion.div {...fadeInUp}>
        <ProductCarouselSection title="Windows Operating Systems" categoryId={1} bgColor="linear-gradient(135deg, #E8F4FD 0%, #D0EAFA 40%, #BFE5F8 100%)" viewAllLink="/shop" />
      </motion.div>

      <motion.div {...fadeInUp}>
        <ProductCarouselSection title="Microsoft Office Suites" categoryId={2} viewAllLink="/shop" />
      </motion.div>

      <motion.div {...fadeInUp}>
        <WhyChooseUs />
      </motion.div>

      <motion.div {...fadeInUp}>
        <ProcessWalkthrough />
      </motion.div>

      <motion.div {...fadeInUp}>
        <CategoryShowcase />
      </motion.div>

      <motion.div {...fadeInUp}>
        <HealthEducation />
      </motion.div>

      <motion.div {...fadeInUp}>
        <Testimonials />
      </motion.div>
      <motion.div {...fadeInUp}>
        <TrustBadges />
      </motion.div>
    </Box>
  );
};

export default HomePage;
